








import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { remove } from 'lodash-es';
import { IS_ANDROID } from '../../service/platform/environment';

const BACKDROP_BODY_CLASS = 'has-backdrop';

@Component({})
export default class Backdrop extends Vue {
  static currentInstances: number[] = [];

  @Prop({
    type: Boolean,
  })
  visible!: boolean;

  @Prop({
    type: String,
  })
  applyFilterFor!: string;

  instanceId = Math.random();

  styleNode = document.createElement('style');

  mounted() {
    this.styleNode.type = 'text/css';
    document.body.appendChild(this.styleNode);
  }

  removeStyle() {
    if (Backdrop.currentInstances.length <= 0) {
      document.body.classList.remove(BACKDROP_BODY_CLASS);
    }
    this.styleNode.remove();
  }

  @Watch('visible', { immediate: true })
  onVisibilityChange(visibility: boolean, prevVisibility: boolean) {
    if (visibility === prevVisibility) return;
    if (visibility) {
      Backdrop.currentInstances.push(this.instanceId);
      document.body.classList.add(BACKDROP_BODY_CLASS);
      this.$emit('show');
    } else {
      remove(Backdrop.currentInstances, (i) => this.instanceId === i);
      if (Backdrop.currentInstances.length <= 0) {
        document.body.classList.remove(BACKDROP_BODY_CLASS);
      }
      this.$emit('hide');
    }
  }

  @Watch('applyFilterFor', { immediate: true })
  onBlurTargetChange(currentTarget: string) {
    this.styleNode.innerHTML = `
${currentTarget},
${currentTarget}:after {
  transition-duration: .32s;
  -webkit-transition-duration: .32s;
}

${currentTarget}:after {
  content: '';
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 200%;
  height: 200%;
  z-index: 100;
}
.${BACKDROP_BODY_CLASS} ${currentTarget} {
  filter: blur(8px);
  -webkit-filter: blur(8px);
}
.${BACKDROP_BODY_CLASS} ${currentTarget}:after {
  background-color: rgba(0, 0, 0, 0.63);
}
`.trim();
  }
}
